/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAiGatewayAzure extends models.GovernanceConfigurationBaseForAiGateway {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAiGatewayAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAiGatewayAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAiGatewayAzure>): GovernanceConfigurationForAiGatewayAzure {
        let obj = Object.assign(new GovernanceConfigurationForAiGatewayAzure(), model);
        GovernanceConfigurationForAiGatewayAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAiGatewayAzure>): GovernanceConfigurationForAiGatewayAzure {
        if (!model) return null;
        return GovernanceConfigurationForAiGatewayAzure.newInstance(<GovernanceConfigurationForAiGatewayAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAiGatewayAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForAiGatewayAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAiGatewayAzure): boolean {
        if (models.GovernanceConfigurationBaseForAiGateway.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAiGatewayAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.dimension_details) {
            models.AzureAiGatewayDimensionDetails.fixupPrototype(this.dimension_details);
        }
        if (this.gateway_details) {
            for (let val of this.gateway_details) {
                models.AzureApimResourceGroupDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * API Management services selected, grouped by resource group
     */
    gateway_details: Array<models.AzureApimResourceGroupDetails>;

    /**
     * Dimension details for Azure Apim
     */
    dimension_details: models.AzureAiGatewayDimensionDetails;

}
